/**
 * @generated SignedSource<<ce9722c34717fcb7f741881ad352125d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BulkDeleteExpenseItemsInput = {
  ids?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type bulkDeleteExpenseItemsMutation$variables = {
  input: BulkDeleteExpenseItemsInput;
};
export type bulkDeleteExpenseItemsMutation$data = {
  readonly bulkDeleteExpenseItems: {
    readonly deletedExpenseItemIds: ReadonlyArray<string | null> | null;
  } | null;
};
export type bulkDeleteExpenseItemsMutation = {
  variables: bulkDeleteExpenseItemsMutation$variables;
  response: bulkDeleteExpenseItemsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkDeleteExpenseItemsPayload",
    "kind": "LinkedField",
    "name": "bulkDeleteExpenseItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedExpenseItemIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkDeleteExpenseItemsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkDeleteExpenseItemsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b7a252821d7f8457223d2e711673ed66",
    "id": null,
    "metadata": {},
    "name": "bulkDeleteExpenseItemsMutation",
    "operationKind": "mutation",
    "text": "mutation bulkDeleteExpenseItemsMutation(\n  $input: BulkDeleteExpenseItemsInput!\n) {\n  bulkDeleteExpenseItems(input: $input) {\n    deletedExpenseItemIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f82b26d01f033418ea0ec985e7eba40";

export default node;
